module.exports = __webpack_public_path__ + "static/media/my-history.ed85ca72.png";